import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './VideoHub.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days < 1) return 'Hari ini';
  if (days < 30) return `${days} hari lalu`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} bulan lalu`;
  return `${Math.floor(months / 12)} tahun lalu`;
}

export default function VideoHub({ eyebrow = 'Video Hub', title = 'Terbaru dari Kami' }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/videos/public?limit=6`)
      .then((res) => {
        if (mounted) setVideos(res.data.data || []);
      })
      .catch(() => {
        if (mounted) setVideos([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!loading && videos.length === 0) return null;

  return (
    <section className="video-hub reveal">
      <div className="video-hub__header">
        <div>
          <span className="video-hub__eyebrow">{eyebrow}</span>
          <h2 className="video-hub__title">{title}</h2>
        </div>
        <Link to="/videos" className="video-hub__see-all">Lihat Semua Video →</Link>
      </div>

      {loading ? (
        <div className="video-hub__empty">Memuat video...</div>
      ) : (
        <div className="video-hub__grid">
          {videos.map((v, i) => (
            <button
              key={v.id}
              className={`video-card ${i === 0 ? 'video-card--featured' : ''}`}
              onClick={() => setActiveVideo(v.youtube_video_id)}
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="video-card__thumb">
                <img
                  src={
                    v.thumbnail_url ||
                    `https://img.youtube.com/vi/${v.youtube_video_id}/hqdefault.jpg`
                  }
                  alt={v.title}
                  loading="lazy"
                />
                <span className="video-card__play">▶</span>
                {v.is_label_channel && (
                  <span className="video-card__badge">Saskara Record</span>
                )}
              </div>
              <div className="video-card__body">
                <p className="video-card__title">{v.title}</p>
                <p className="video-card__meta">
                  {v.artist_name && `${v.artist_name} · `}
                  {timeAgo(v.published_at)}
                </p>
              </div>
            </button>
          ))}
        </div>
      )}

      {activeVideo && (
        <div className="video-modal" onClick={() => setActiveVideo(null)}>
          <div className="video-modal__frame" onClick={(e) => e.stopPropagation()}>
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
              title="Video player"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
            <button className="video-modal__close" onClick={() => setActiveVideo(null)}>
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
